// --- DEPENDENCY WAITERS ---
// Added a max timeout (5 seconds) so the browser doesn't loop infinitely if a script fails to load
function waitForDeps(callback, attempts = 0) {
  const maxAttempts = 100; // 100 * 50ms = 5 seconds
  if (window.pako?.ungzip && window.jQuery && $.fn.DataTable) {
    callback();
  } else if (attempts < maxAttempts) {
    setTimeout(() => waitForDeps(callback, attempts + 1), 50);
  } else {
    console.error('Failed to load dependencies (pako, jQuery, or DataTables)');
    $('#loadingScreen').hide();
  }
}

function waitForDataTables(callback, attempts = 0) {
  const maxAttempts = 100;
  if ($.fn.DataTable) {
    callback();
  } else if (attempts < maxAttempts) {
    setTimeout(() => waitForDataTables(callback, attempts + 1), 50);
  } else {
    console.error('DataTables failed to load');
  }
}

// --- STRING HELPERS ---
// This is perfect, no changes needed.
const handlize = (str) =>
  str
    .toLowerCase()
    .trim()
    .replace(/['"`]/g, "") 
    .replace(/[^a-z0-9]+/g, "-") 
    .replace(/^-+|-+$/g, ""); 

// --- NETWORK & COMPRESSION ---
async function fetchGzippedJson(url) {
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
    const arrayBuffer = await res.arrayBuffer();
    const uint8 = new Uint8Array(arrayBuffer);
    const decompressed = window.pako.ungzip(uint8, { to: "string" });
    return JSON.parse(decompressed);
  } catch (error) {
    console.error('Failed to fetch or decompress JSON:', error);
    return null;
  }
}

// --- INDEXED DB CORE ---
async function openDB() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open("ProductCache", 1);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('products')) {
        db.createObjectStore("products", { keyPath: "id" });
      }
    };

    request.onsuccess = (event) => resolve(event.target.result);
    request.onerror = (event) => reject(event.target.error);
    request.onblocked = () => console.warn("IndexedDB blocked! Close other tabs.");
  });
}

async function storeProductsInIndexedDB(jsonData) {
  const db = await openDB();
  const tx = db.transaction("products", "readwrite");
  const store = tx.objectStore("products");

  // ✅ CRITICAL FIX: Clear old products before writing new ones
  // This prevents "ghost" products from staying in the cache forever
  store.clear(); 

  // Store version if it exists
  if (jsonData.version) {
    store.put({ id: "version", version: jsonData.version });
  }

  jsonData.products.forEach((product) => {
    if (!product.id) {
      // Fallback ID generation (better to use a stable hash if possible)
      product.id = `fallback-${product.title?.trim().toLowerCase() || crypto.randomUUID()}`;
    }
    store.put(product);
  });

  await tx.done;
}

async function getCachedProducts() {
  const db = await openDB();
  const tx = db.transaction("products", "readonly");
  const store = tx.objectStore("products");
  
  // Modern IDB pattern: await tx.done ensures the transaction doesn't close prematurely
  const request = store.getAll();
  return new Promise((resolve, reject) => {
    request.onsuccess = () => {
      // Filter out the "version" row so we only return actual products
      const products = request.result.filter(item => item.id !== "version");
      resolve(products);
    };
    request.onerror = () => reject(request.error);
  });
}

// --- MAIN LOADER LOGIC ---
async function loadProducts(url, uniqueKey) {
  $("#loadingScreen").show();

  try {
    // 1. Try to get data from the instant IndexedDB cache first
    let data = await getCachedProducts();

    // 2. If cache is empty, we MUST fetch from the network
    if (!data || data.length === 0) {
      const jsonData = await fetchGzippedJson(url);
      
      if (jsonData && jsonData.products) {
        await storeProductsInIndexedDB(jsonData);
        data = jsonData.products;
      } else {
        console.error('Could not load product data');
        $("#loadingScreen").hide();
        return;
      }
    }

    // 3. Process and build
    data = getUniqueRows(data, uniqueKey);
    buildTable(data);

  } catch (error) {
    console.error('Error in loadProducts:', error);
    $("#loadingScreen").hide();
  }
}

// --- DATA MANIPULATION ---
function getUniqueRows(data, key) {
  if (!key) return data;

  const seen = new Set();
  return data.filter((item) => {
    const value = item[key];
    if (!value || seen.has(value)) return false;
    seen.add(value);
    return true;
  });
}

function filterData(data, filterKey, filterValue) {
  if (!filterKey || !filterValue) return data;

  const seen = new Set();
  return data.filter((item) => {
    // ✅ CRITICAL FIX: Deduplicate by the DYNAMIC key, not hardcoded 'genre'
    const val = item[filterKey];
    if (!val || seen.has(val)) return false;
    
    seen.add(val);
    return val.toLowerCase() === filterValue.toLowerCase();
  });
}

// ❌ REMOVED: debugIndexedDB(); 
// Do not call this on load. It reads the entire database into memory for no reason.
// If you need to debug, open your browser console and type debugIndexedDB() manually.